import { FAQ } from '../components/home/FAQ';

export default function FaqPage() {
  return <FAQ />;
}
